import uhLogo from '../../../../assets/images/users/uh-logo.svg';

export default function LogoIcon() {
  return <img src={uhLogo} alt="UH Logo" width={90} />;
}
